import React from 'react';
import { I18n } from '../../../helpers/i18n';
import starActive from '../../../static/images/mvp/star_active.png';
import starInactive from '../../../static/images/mvp/star_in_active.png';
import './CompactRatingDisplay.css';

/**
 * Compact rating badge: star + score only (no ratings count).
 * Pill-shaped, dark background. Clickable to open rating list.
 */
function CompactRatingDisplay({ score = 0, hasRating = false, onClick }) {
  if (hasRating) {
    return (
      <div className="compact-rating" onClick={onClick}>
        <img src={starActive} alt="compact-rating-star" className="compact-rating-star" />
        <span className="compact-rating-score">{score}</span>
      </div>
    );
  }

  return (
    <div className="compact-rating-no-bg" onClick={onClick}>
      <img src={starInactive} alt="compact-rating-star" className="compact-rating-star" />
      <span className="compact-rating-none">{I18n.t('no_rating')}</span>
    </div>
  );
}

export default CompactRatingDisplay;
